import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { UrlConstant } from './constants/url-constant';
import { AppData } from './constants/app-data';
import { DataService } from './data.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {
  title = 'Ols';
  drawerVisible: boolean;
  
  @ViewChild('leftNavMenuDrawer')  public leftNavMenuDrawer: any;
  @ViewChild('rightNavMenuDrawer') public rightNavMenuDrawer: any;
  
  constructor(private appData: AppData, private dataService: DataService, private router: Router,
  	 ) {
  	//console.log('AppComponent constructor');
  }
    
    ngOnInit(): void {
    	//console.log('AppComponent ngOnInit');
    	//this.router.navigate(['/test-dashboard', { }]);
    	//this.router.navigate(['/home', { }]);
    	//console.log('this.leftNavMenuDrawer::' + this.leftNavMenuDrawer);
    	//this.appData.drawerVisible.subscribe(message=> this.drawerVisible = message);
    	this.appData.leftNavMenuDrawer.next(this.leftNavMenuDrawer);
    	this.appData.rightNavMenuDrawer.next(this.rightNavMenuDrawer);
    	
    }
    
    ngAfterViewInit(): void {
    	this.appData.leftNavMenuDrawer.next(this.leftNavMenuDrawer);
    	this.appData.rightNavMenuDrawer.next(this.rightNavMenuDrawer);
    }
    
}
